'use strict';

var self = module.exports = {

  /************************************************************************************************************************
   * Init
   /***********************************************************************************************************************/

  init: function () {

    var $canvas = $('.canvas'),
      $rotationValue = 45;

    /************************************************************************************************************************
     * Seleziona un elemento
     /***********************************************************************************************************************/

    $canvas.on('click', '.draggable', function() {
      var $element = $(this);
      self.selected($element);
    });

    /************************************************************************************************************************
     * Rotazione di un elemento
     /***********************************************************************************************************************/

    $('[data-js="draggable-rotate"]').click(function() {
      var $element = $canvas.find('.draggable_selected').find('.draggable__item'),
        $rotate = $element.data('rotate'),
        $flipX = $element.data('flipX'),
        $flipY = $element.data('flipY');

      /**
       * Applica una rotazione negativa o positiva
       * se l'elemento è stato flippato oppure no
       * questo perché applicando una trasfomazione CSS di tipo scala all'oggetto
       * il senso della rotazione cambia
       */
      if($flipX + $flipY == 0) {
        $rotate -= $rotationValue;
      } else {
        $rotate += $rotationValue;
      }

      $element
        .data('rotate', $rotate)
        .css('transform', 'scale(' + $flipX + ',' + $flipY + ') rotate(' + $rotate + 'deg)');

    });

    /************************************************************************************************************************
     * Riflessione orizzontale di un elemento
     /***********************************************************************************************************************/

    $('[data-js="draggable-flip-horizontal"]').click(function() {
      var $element = $canvas.find('.draggable_selected').find('.draggable__item'),
        $rotate = $element.data('rotate'),
        $flipX = $element.data('flipX'),
        $flipY = $element.data('flipY');

      if($flipX < 0) {
        $element
          .data('flipX', 1)
          .css('transform', 'scale(1, ' + $flipY + ') rotate(' + $rotate + 'deg)');
      } else {
        $element
          .data('flipX', -1)
          .css('transform', 'scale(-1, ' + $flipY + ') rotate(' + $rotate + 'deg)');
      }
    });

    /************************************************************************************************************************
     * Riflessione verticale di un elemento
     /***********************************************************************************************************************/

    $('[data-js="draggable-flip-vertical"]').click(function() {
      var $element = $canvas.find('.draggable_selected').find('.draggable__item'),
        $rotate = $element.data('rotate'),
        $flipX = $element.data('flipX'),
        $flipY = $element.data('flipY');

      if($flipY < 0) {
        $element
          .data('flipY', 1)
          .css('transform', 'scale(' + $flipX + ', 1) rotate(' + $rotate + 'deg)');
      } else {
        $element
          .data('flipY', -1)
          .css('transform', 'scale(' + $flipX + ', -1) rotate(' + $rotate + 'deg)');
      }
    });

    /************************************************************************************************************************
     * Elimina un singolo elemento
     /***********************************************************************************************************************/

    $('[data-js="draggable-delete"]').click(function() {
      var $element = $canvas.find('.draggable_selected');

      if($element.hasClass('draggable_theme_all')) {
        $element.remove();
        canvas.close($('.canvas__footer'));
      } else {
        $('#modal-delete-denied').foundation('open');
      }

    });
  },

  /************************************************************************************************************************
   * Selezione di un elemento draggable
   /***********************************************************************************************************************/

  selected: function(element) {

    var $canvas = $('.canvas');

    if(element.hasClass('draggable_selected')) {

      element.removeClass('draggable_selected');

      canvas.close($('.canvas__footer'));

      return;
    }

    $canvas
      .find('.draggable')
      .removeClass('draggable_selected');

    element.addClass('draggable_selected');

    canvas.open($('.canvas__footer'));
  }
}

self.init();
